<template>
  <div class="milestone-swiper-wrapper">
    <!-- 内容展示区 -->
    <div class="swiper-container milestone-swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in milestoneList" :key="index">
          <div class="timeline_display">
            <div class="display_left">
              <div class="display_year">
                <template v-if="$i18n.locale === 'zh'">{{ item.titleCn || item.titleEn }}</template>
                <template v-else-if="$i18n.locale === 'es'">{{ item.titleEs || item.titleEn }}</template>
                <template v-else>{{ item.titleEn }}</template>
              </div>
              <div class="vertical_line"></div>
              <div class="display_event">
                <template v-if="$i18n.locale === 'zh'">{{ item.contentCn || item.contentEn }}</template>
                <template v-else-if="$i18n.locale === 'es'">{{ item.contentEs || item.contentEn }}</template>
                <template v-else>{{ item.contentEn }}</template>
              </div>
            </div>
            <div class="display_right">
              <img v-if="item.image" :src="item.image" alt="milestone" class="display_image" />
              <div v-else class="display_image_placeholder"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 横向时间线 -->
    <div class="timeline_wrapper">
      <div class="timeline_arrow arrow_prev" @click="handlePrev" :class="{ disabled: activeIndex === 0 }">
        <img src="../../../static/img/green-left.png" alt="Previous" />
      </div>
      <div class="timeline_track">
        <div
          class="timeline_node"
          v-for="(item, index) in milestoneList"
          :key="index"
          :class="{ active: activeIndex === index }"
          @click="handleNodeClick(index)"
        >
          <div class="node_year">
            <template v-if="$i18n.locale === 'zh'">{{ item.titleCn || item.titleEn }}</template>
            <template v-else-if="$i18n.locale === 'es'">{{ item.titleEs || item.titleEn }}</template>
            <template v-else>{{ item.titleEn }}</template>
          </div>
          <img
            :src="activeIndex === index ? require('../../../static/img/year_dot_green.png') : require('../../../static/img/year_dot.png')"
            alt="Timeline node"
            class="node_dot"
          />
        </div>
      </div>
      <div class="timeline_arrow arrow_next" @click="handleNext" :class="{ disabled: activeIndex === milestoneList.length - 1 }">
        <img src="../../../static/img/green-right.png" alt="Next" />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper-bundle.css";

export default {
  props: {
    milestoneList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiper: null,
      activeIndex: 0
    };
  },
  watch: {
    milestoneList() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
  methods: {
    initSwiper() {
      if (this.swiper) {
        this.swiper.destroy();
      }

      const that = this;
      this.swiper = new Swiper(".milestone-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        on: {
          slideChange: function () {
            that.activeIndex = this.activeIndex;
          }
        }
      });
    },
    handlePrev() {
      if (this.activeIndex > 0 && this.swiper) {
        this.swiper.slidePrev();
      }
    },
    handleNext() {
      if (this.activeIndex < this.milestoneList.length - 1 && this.swiper) {
        this.swiper.slideNext();
      }
    },
    handleNodeClick(index) {
      if (this.swiper) {
        this.swiper.slideTo(index);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.milestone-swiper-wrapper {
  position: relative;
  padding-top: 12rem;

  .milestone-swiper {
    margin-bottom: 14rem;
  }

  ::v-deep .swiper-container {
    height: 45rem !important;
  }

  .timeline_display {
    display: flex;
    align-items: center;
    gap: 13rem;
    min-height: 10rem;
    padding-right: 0.1rem;

    .display_left {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .display_year {
        font-size: 5rem;
        font-family: bold;
        color: #212121;
        margin-bottom: 1.2rem;
        border: 2px solid #5B6370;
        padding: 2rem 5rem 1.1rem;
        width: fit-content;
        border-radius: 1.2rem;
        line-height: 1;
      }

      .vertical_line {
        width: 0.2rem;
        height: 6rem;
        background-color: #5B6370;
        margin: 2rem auto 4rem;
      }

      .display_event {
        font-size: 2.2rem;
        color: #838383;
        line-height: 3rem;
        font-family: regular;
      }
    }

    .display_right {
      flex: 1;

      .display_image {
        width: 100%;
        height: 45rem;
        object-fit: cover;
        border-radius: 1rem;
        margin-right: 0.5rem;
      }

      .display_image_placeholder {
        width: 100%;
        height: 30rem;
        background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
        border-radius: 1rem;
      }
    }
  }

  .timeline_wrapper {
    position: relative;
    padding: 0 4rem;
    height: 10rem;

    .timeline_arrow {
      position: absolute;
      bottom: 0.6rem;
      transform: translateY(50%);
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      font-size: 1.6rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      z-index: 2;
      outline: none;

      img {
        width: 4.5rem;
        height: 4.5rem;
      }

      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      &.arrow_prev { left: 0; }
      &.arrow_next { right: 0; }
    }
  }

  .timeline_track {
    display: flex;
    align-items: flex-end;
    position: relative;
    padding-bottom: 0;
    margin: 0 1rem 2rem 1rem;
    height: 100%;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0.6rem;
      height: 2px;
      background: #BDC0C5;
      z-index: 0;
    }

    .timeline_node {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      position: relative;
      z-index: 1;

      .node_year {
        font-size: 2rem;
        font-family: medium;
        color: #8A9099;
        margin-bottom: 4rem;
        transition: all 0.3s;
        white-space: nowrap;
      }

      .node_dot {
        position: absolute;
        bottom: 0.6rem;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background: white;
        transition: all 0.3s;
      }

      &.active {
        .node_year {
          font-size: 3.5rem;
        }

        .node_dot {
          width: 4.5rem;
          height: 4.5rem;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .milestone-swiper-wrapper {
    padding-top: 6rem;

    .milestone-swiper {
      margin-bottom: 0;
    }

    ::v-deep .swiper-container {
      height: auto !important;
    }

    .timeline_display {
      gap: 2rem;
      flex-direction: column;

      .display_left {
        .display_year {
          font-size: 3rem;
          padding: 1.5rem 3rem 1rem;
        }

        .vertical_line {
          height: 4rem;
          margin: 1.5rem auto 2rem;
        }

        .display_event {
          font-size: 1.6rem;
          line-height: 2.4rem;
        }
      }

      .display_right {
        .display_image {
          height: 25rem;
        }
      }
    }

    .timeline_wrapper {
      padding: 0 2rem;

      .timeline_arrow {
        width: 2rem;
        height: 2rem;

        img {
          width: 2.5rem;
          height: 2.5rem;
        }
      }
    }

    .timeline_track {
      margin: 0 0.5rem 1rem 0.5rem;

      .timeline_node {
        .node_year {
          font-size: 1.1rem;
          margin-bottom: 2rem;
        }
        .node_dot {
          width: 0.7rem;
          height: 0.7rem;
        }
        &.active {
          .node_year {
            font-size: 1.4rem;
          }

          .node_dot {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
